import React from 'react';
import InputWithShortcuts from 'src/components/inputs/inputWithShortcuts';
import SelectMenu from 'src/components/selectMenu';

interface IFiltersDomainProps {
  onSearch: (value: string) => void;
  onOptionSecurityChange: (value: string) => void;
  onOptionScopeChange: (value: string) => void;
  optionsScope: { value: string; label: string }[];
  optionsSecurity: { value: string; label: string }[];
}

export const FiltersDomain: React.FC<IFiltersDomainProps> = ({
  onSearch,
  onOptionSecurityChange,
  onOptionScopeChange,
  optionsScope,
  optionsSecurity
}) => {
  return (
    <div className="flex flex-row justify-start items-start">
      <InputWithShortcuts
        onSearch={(value) => onSearch(value)}
        placeholder="Host"
        className="w-[20vw] mr-2"
      />
      <SelectMenu
        options={optionsScope}
        onChange={onOptionScopeChange}
        placeholder="Scope"
        className="w-[12vw] text-gray-700 mr-2"
        defaultValue="GET"
      />
      <SelectMenu
        options={optionsSecurity}
        onChange={onOptionSecurityChange}
        placeholder="Security"
        className="w-[12vw] text-gray-700"
        defaultValue="GET"
      />
    </div>
  );
}; 